import { View, StyleSheet, Text, Dimensions } from "react-native";
import Plaid from "./Plaid";
import { Title } from "../accessories/accessories";
import { web } from "../accessories/Platform";
import CustomText from "../accessories/CustomText";
import RadioButtonGroup, {
  RadioButtonItem,
} from "../accessories/RadioButtonGroup";
import ExternalSourceViewer from "../accessories/ExternalSourceViewer";

const BorrowerVerification = ({
  detailsArr,
  handleOptionPress,
  LockLoanApp,
  loanId,
  userId,
  assetVendor = "Truv",
  handleNavigation = () => {},
  handleGetBankEmpDetails = () => {},
}) => {
  return (
    <View>
      {!(
        detailsArr["bodyContent"] === "LinkBankAccount" &&
        detailsArr["isBankAccountLinked"] !== 1 &&
        detailsArr["viewPlaid"]
      ) && (
        <>
          <Title text={detailsArr["Title"]} />
          <RadioButtonGroup
            size={22}
            radioBackground="#295b9a"
            onSelected={(value) => handleOptionPress(value)}
            selected={detailsArr["ColumnValue"]}
          >
            {detailsArr["Options"]?.map((item, index) => {
              return (
                <RadioButtonItem
                  key={index}
                  style={{ alignSelf: "flex-start", marginTop: 8 }}
                  value={item["value"]}
                  label={
                    <View style={{ flexDirection: "column" }}>
                      <CustomText bold={true} style={[styles.labelStyle]}>
                        {item["text"]}
                      </CustomText>
                      {item["additionalText"] && (
                        <CustomText
                          style={{
                            fontSize: 13,
                            marginTop: 7,
                            marginBottom: 15,
                            marginLeft: 5,
                          }}
                        >
                          {item["additionalText"]}
                        </CustomText>
                      )}
                    </View>
                  }
                />
              );
            })}
          </RadioButtonGroup>
        </>
      )}
      {detailsArr["bodyContent"] &&
        detailsArr["bodyContent"] === "LinkBankAccount" &&
        detailsArr["viewPlaid"] && (
          <>
            {assetVendor === "Truv" ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  height: Dimensions.get("window").height - 320,
                }}
              >
                <ExternalSourceViewer
                  handleNavigation={handleNavigation}
                  handleGetBankEmpDetails={handleGetBankEmpDetails}
                  url={`https://directmortgage.com/Truv/?lId=${loanId}&cId=${userId}&t=income`}
                  style={{ height: Dimensions.get("window").height - 320 }}
                  wStyle={{ height: Dimensions.get("window").height - 320 }}
                />
              </View>
            ) : (
              <Plaid
                handleFrameNavigation={detailsArr["handleFrameNavigation"]}
                handleOptionPress={handleOptionPress}
                details={detailsArr["details"]}
                handleSaveLoanInformation={
                  detailsArr["handleSaveLoanInformation"]
                }
                isBankAccountLinked={detailsArr["isBankAccountLinked"]}
              />
            )}

            {web && (
              <>
                <div id="divPlaidContainer"></div>
                <a id="downloadAnchorElem" style={{ display: "none" }}></a>
              </>
            )}
          </>
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  labelStyle: {
    fontSize: 16,
    marginLeft: 5,
    marginTop: 7,
  },
});

export default BorrowerVerification;
